/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetRewardConfigsResponseAllOf,
    GetRewardConfigsResponseAllOfFromJSON,
    GetRewardConfigsResponseAllOfFromJSONTyped,
    GetRewardConfigsResponseAllOfToJSON,
    PaginatedResponse,
    PaginatedResponseFromJSON,
    PaginatedResponseFromJSONTyped,
    PaginatedResponseToJSON,
    PaginationInfo,
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    RewardConfigResponse,
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetRewardConfigsResponse
 */
export interface GetRewardConfigsResponse extends PaginatedResponse {
    /**
     * 
     * @type {Array<RewardConfigResponse>}
     * @memberof GetRewardConfigsResponse
     */
    rewards: Array<RewardConfigResponse>;
}

export function GetRewardConfigsResponseFromJSON(json: any): GetRewardConfigsResponse {
    return GetRewardConfigsResponseFromJSONTyped(json, false);
}

export function GetRewardConfigsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRewardConfigsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...PaginatedResponseFromJSONTyped(json, ignoreDiscriminator),
        'rewards': ((json['rewards'] as Array<any>).map(RewardConfigResponseFromJSON)),
    };
}

export function GetRewardConfigsResponseToJSON(value?: GetRewardConfigsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...PaginatedResponseToJSON(value),
        'rewards': ((value.rewards as Array<any>).map(RewardConfigResponseToJSON)),
    };
}


